export const MAX_NAME_LENGTH = 25;
export const MAX_EMAIL_LENGTH = 100;
export const MAX_DONATION_VALUE = 999999.99;
export const MAX_BANK_ACCOUNT_DONATION_VALUE = 90000;
export const MAX_COMPANY_NAME_LENGTH = 100;
export const MAX_DONATION_MESSAGE_OF_SUPPORT_LENGTH = 280;
export const MAX_DONATION_COMMENT_LENGTH = 280;
export const FORMBUILDER_ADDRESS = {
    STREET_MAX_LENGTH: 100,
    CITY_MAX_LENGTH: 50,
    STATE_MAX_LENGTH: 50,
    POST_CODE_MAX_LENGTH: 10,
    COUNTRY_MAX_LENGTH: 50,
};
export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";
export const DEFAULT_TIME_FORMAT = "HH:mm";
export const DECIMAL_FRACTIONS = {
    DEFAULT: 2,
    NO_CENTS: 0
}